import { render, staticRenderFns } from "./ValidationContainer.vue?vue&type=template&id=2e502841&scoped=true&"
var script = {}
import style0 from "./ValidationContainer.vue?vue&type=style&index=0&id=2e502841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e502841",
  null
  
)

export default component.exports